import { z } from 'zod';
export const v1EditsFileFocusSchema = z.object({
    filePath: z.string(),
    sessionId: z.string(),
});
export const v1EditsFileReadSchema = z.object({
    filePath: z.string(),
    fileContent: z.string(),
    sessionId: z.string(),
});
export const v1EditsFileRewriteSchema = z.object({
    filePath: z.string(),
    fileContent: z.string(),
    sessionId: z.string(),
});
export const v1EditsIntroductionSchema = z.object({
    sessionId: z.string(),
    client: z.enum(['studio', 'sandbox-daemon', 'sandbox-frontend']),
});
//# sourceMappingURL=socket-types.js.map